import React from 'react';
import { Input } from 'semantic-ui-react';

const FormField = (props: any) => {
	const { labelText, Component, styles } = props;
	return (
		<div
			className={'kootenai-form-field'}
			style={labelText ? {} : { paddingTop: 20 }}
		>
			<p style={{ margin: 0 }}>{labelText}</p>
			{Component ? (
				Component
			) : (
				<Input
					type={'text'}
					className={'kootenai-normal-input'}
					fluid
					onChange={props.onChange}
					{...props}
				/>
			)}
		</div>
	);
};

export default FormField;
